export default {
  home_hero_title1: '全网热搜爆料',
  home_hero_title2: '吃瓜一线直击',
  home_hero_subtitle: '每日不间断追踪娱乐圈网红内幕、明星翻车现场，全部内容免费浏览，做最懂你的吃瓜平台。',
  home_hero_cta: '立即吃瓜',
  home_hero_viewMore: '浏览更多',
  home_hotNews_title1: '今日热门',
  home_hotNews_title2: '吃瓜追踪',
  home_hotNews_subtitle: '全网最火爆的瓜，一个不落',
  home_latestNews_title1: '最新瓜料',
  home_latestNews_title2: '实时更新',
  home_latestNews_subtitle: '刚刚出炉的新鲜瓜，趁热吃',
  home_comments_label: '瓜友热评',
  home_comments_title1: '千万瓜友',
  home_comments_title2: '在线验证',
  home_comments_subtitle: '每一口瓜都经过真实吃瓜群众检验',
  home_cta_title: '不错过任何一个瓜',
  home_cta_subtitle: '订阅每日吃瓜推送，第一时间掌握最新爆料',
  home_cta_button: '免费订阅',
};